/**
 * Navbar
 */

export default function() {

    const navbar = document.querySelector('[data-component="navbar"]');
    const bars = document.querySelector('.bars');
    const mobnav = document.querySelector('.nav-list--dropdown');

    // When navbar exists
    if (navbar) {

        document.addEventListener('click', function (event) {

            // If the clicked element doesn't have the right selector, bail
            if (!event.target.closest('[data-js="js_navbar-toggler"]')) return;

            event.preventDefault();

            bars.classList.toggle('open');
            mobnav.classList.toggle('is-visible');

        }, false);
    }
}